export enum CreditSafePortfolioEventRuleStatus {
    Active = 'active',
    Disabled = 'disabled',
}
